// extracted by mini-css-extract-plugin
module.exports = {"Root":"DrawerMenuItem_Root__3-5De"};